import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import ArtworkDetail from "@/pages/ArtworkDetail";
import Poems from "@/pages/Poems";
import PoemDetail from "@/pages/PoemDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import StaticPage from "@/pages/StaticPage";
import SearchPage from "@/pages/Search";
import NotFound from "@/pages/NotFound";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerRegister from "@/pages/CustomerRegister";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CustomerAccount from "@/pages/CustomerAccount";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminArtworks from "@/pages/admin/AdminArtworks";
import ArtworkForm from "@/pages/admin/ArtworkForm";
import AdminPoems from "@/pages/admin/AdminPoems";
import PoemForm from "@/pages/admin/PoemForm";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminOrderRequests from "@/pages/admin/AdminOrderRequests";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CustomerAuthProvider>
          <Toaster position="top-center" />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/galerie/:slug" element={<ArtworkDetail />} />
              <Route path="/gedichte" element={<Poems />} />
              <Route path="/gedichte/:slug" element={<PoemDetail />} />
              <Route path="/ueber-mich" element={<About />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/suche" element={<SearchPage />} />
              <Route path="/anmelden" element={<CustomerLogin />} />
              <Route path="/registrieren" element={<CustomerRegister />} />
              <Route path="/email-bestaetigen" element={<VerifyEmail />} />
              <Route path="/passwort-vergessen" element={<ForgotPassword />} />
              <Route path="/passwort-zuruecksetzen" element={<ResetPassword />} />
              <Route path="/konto" element={<CustomerAccount />} />
              <Route path="/impressum" element={<StaticPage pageKey="impressum" />} />
              <Route path="/datenschutz" element={<StaticPage pageKey="datenschutz" />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<Dashboard />} />
                <Route path="/admin/kunstwerke" element={<AdminArtworks />} />
                <Route path="/admin/kunstwerke/neu" element={<ArtworkForm />} />
                <Route path="/admin/kunstwerke/:id" element={<ArtworkForm />} />
                <Route path="/admin/gedichte" element={<AdminPoems />} />
                <Route path="/admin/gedichte/neu" element={<PoemForm />} />
                <Route path="/admin/gedichte/:id" element={<PoemForm />} />
                <Route path="/admin/medien" element={<AdminMedia />} />
                <Route path="/admin/anfragen" element={<AdminRequests />} />
                <Route path="/admin/bestellanfragen" element={<AdminOrderRequests />} />
                <Route path="/admin/newsletter" element={<AdminNewsletter />} />
                <Route path="/admin/einstellungen" element={<AdminSettings />} />
              </Route>
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
          </CustomerAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
